import { html, nothing } from 'lit';
import { Purpose } from '@common/types/model';
import type { TefComs4p } from '@src/components/TefComs4p';
import { consentStore } from '@src/store';

//
// renders the main component view in VIEW mode
//
export const tefComs4pView = function render(this: TefComs4p) {
  return html`
    <div class="container" data-testid="root">
      <section cloak=${this.cloak || nothing}>
        <h4 class="typography-display--4">Partner-APP Einstellungen</h4>
        <p>
          Im Folgenden ist es möglich, für jede Partner-APP den Verarbeitungen personenbezogener Daten auf Grundlage gesetzlicher Bestimmungen zu widersprechen und die ggf. erteilten Einwilligungen einzusehen.
        </p>
        <p>
          Nähere Informationen zu den Partner-Services und Verarbeitungszwecken sind unter Partner-Services Einstellungen zu finden.
        </p>
        ${consentStore.actualConsents.map((purpose : Purpose) => this.getTemplateFn('singlePurposeView')(purpose))}
      </section>
      <tef-coms-back-button text="Zurück"></tef-coms-back-button>
    </div>
    `;
};
